import React, { useEffect, useState, useContext, useRef } from "react";
import { CarrierContext } from "../contexts/CarrierContext";
import { LanguageContext } from "../contexts/LanguageContext";
import HeaderPayment from "./HeaderPayment";
import Footer from "./Footer";
import Breadcrumbs from "./Breadcrumbs";

function ContactUs({ contact }) {
  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const mainContactusContentsReff = useRef(null);
  const [cms, setPaymentCMS] = useState("");
  const [langSelected, setLangSelected] = useState(
    () => sessionStorage.getItem("langSel") || "eng"
  ); // default language

  useEffect(() => {
    if (cmsAllPages && cmsAllPages.contact_us) {
      setPaymentCMS(cmsAllPages.contact_us);
    }
  }, [cmsAllPages, setPaymentCMS]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (mainContactusContentsReff.current) {
        mainContactusContentsReff.current.focus();
      }
    }, 1000); // Delay to ensure the DOM is fully rendered

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;
  // Check if current carrier is excluded for carousel
  const carouselExcludedCarriers = (
      process.env.REACT_APP_CAROUSEL_EXCLUDED_CARRIERS || ""
  )
      .split(",")
      .map((c) => c.trim().toLowerCase());

  const isCarouselExcluded = carouselExcludedCarriers.includes(
      urlCarrier?.toLowerCase()
  );
  return (
    <>
      <div
        id="main-contactus-contents"
        ref={mainContactusContentsReff}
        tabIndex="-1"
      >
        <div id={`header-${urlCarrier}`}>
          <HeaderPayment
            page="contact_us"
            setLangSelected={setLangSelected}
          ></HeaderPayment>
        </div>

        <main id="main" className="main">
          <div>
            <Breadcrumbs cms={cms}></Breadcrumbs>
          </div>
          <div className="container-lg">
            {/* ------Demo header------ */}
            <section className="py-1 pb-5 bg-white mt-4">
              <div className="py-4">
                <div className="content px-xl-4 px-2">
                  <div className="col-12 d-lg-flex align-items-start">
                    <div className="col-xl-5 col-lg-5 col-12 payment text-center mb-3 mb-lg-0">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/illustrations/contact-${urlCarrier}.svg`}
                        className="contact-us-illustration img-fluid"
                        alt="Contact-us"
                      />
                    </div>

                    <div className="col-xl-7 col-lg-7 col-12 contact-us-content-col mt-xl-5 mt-lg-5" tabIndex="0">
                      <div className="mb-1">
                        <h3 className="fw-semibold">{cms?.label_contact_us}</h3>
                        <p className="mt-1" style={{ fontSize: "12px" }}>
                          {cms?.label_contact_us_help_text}
                        </p>
                      </div>

                      <div className="col-12 mt-4 content-label">
                        <div className="row g-3">
                          <div className="col-12 col-sm-6 contact-info-item">
                            <img
                              className="margin-3rem"
                              src={
                                urlCarrier === "bcbsaz"
                                  ? `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile-bcbsaz.svg`
                                  : `${process.env.PUBLIC_URL}/images/icons/Payment/Mobile.svg`
                              }
                              alt="Mobile"
                            />
                            <label>
                              <b className="fw-semibold">
                                {cms?.label_contact_number_label}:
                              </b>{" "}
                              <span className="d-inline-block ms-1 contact-label-val">{cms?.label_contact_number_value}</span>                              
                            </label>
                          </div>
                          <div className="col-12 col-sm-6 contact-info-item">
                            <label>
                              <img
                                className="margin-3rem"
                                src={
                                  urlCarrier === "bcbsaz"
                                    ? `${process.env.PUBLIC_URL}/images/icons/clock-bcbsaz.svg`
                                    : `${process.env.PUBLIC_URL}/images/icons/clock.svg`
                                }
                                alt="Time"
                              />
                              <b className="fw-semibold">
                                {cms?.label_hours_of_operation}: <br />
                              </b>{" "}
                              <span className="contact-label-val">
                                {cms?.label_hours_of_operation_value_one}
                              </span>{" "}
                              <br />
                              <span className="contact-label-val">
                                {cms?.label_hours_of_operation_value_two}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        {/* ------Demo footer------ */}
        {/* <div id="footer">
                
                </div>  */}
        <Footer cms={cms} />
      </div>
    </>
  );
}

export default ContactUs;
